import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class PayrollSptReportProvider {

  private _service: string = 'payroll';
  private _model: string = 'payrollsptreport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public downloadSptMasa(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadSptMasa';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public downloadSptForm(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadSptForm';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public downloadSptEFilling(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadSptEFilling';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public download1721A1(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'download1721A1';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public download1721A1All(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'download1721A1All';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlob(_method, _url, _func, _params, _body);
  }

  public down1721A1All(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'download1721A1All';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/payroll-spt-report/payroll-spt-report.ts